import { render, staticRenderFns } from "./topbar-buttons-block.vue?vue&type=template&id=4610b3a4"
import script from "./topbar-buttons-block.vue?vue&type=script&lang=js"
export * from "./topbar-buttons-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/topbar/topbar-buttons-block.vue
// module id = Ti1s
// module chunks = 0